module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.containerClass
  }, [_c('INInputText', _vm._g(_vm._b({
    ref: "input",
    class: ['p-inputnumber-input', _vm.inputClass],
    style: (_vm.inputStyle),
    attrs: {
      "value": _vm.formattedValue,
      "aria-valumin": _vm.min,
      "aria-valuemax": _vm.max
    }
  }, 'INInputText', _vm.$attrs, false), _vm.listeners)), _vm._v(" "), (_vm.showButtons && _vm.buttonLayout === 'stacked') ? _c('span', {
    staticClass: "p-inputnumber-button-group"
  }, [_c('INButton', _vm._g({
    class: _vm.upButtonClass,
    attrs: {
      "icon": _vm.incrementButtonIcon,
      "disabled": _vm.$attrs.disabled
    }
  }, _vm.upButtonListeners)), _vm._v(" "), _c('INButton', _vm._g({
    class: _vm.downButtonClass,
    attrs: {
      "icon": _vm.decrementButtonIcon,
      "disabled": _vm.$attrs.disabled
    }
  }, _vm.downButtonListeners))], 1) : _vm._e(), _vm._v(" "), (_vm.showButtons && _vm.buttonLayout !== 'stacked') ? _c('INButton', _vm._g({
    class: _vm.upButtonClass,
    attrs: {
      "icon": _vm.incrementButtonIcon,
      "disabled": _vm.$attrs.disabled
    }
  }, _vm.upButtonListeners)) : _vm._e(), _vm._v(" "), (_vm.showButtons && _vm.buttonLayout !== 'stacked') ? _c('INButton', _vm._g({
    class: _vm.downButtonClass,
    attrs: {
      "icon": _vm.decrementButtonIcon,
      "disabled": _vm.$attrs.disabled
    }
  }, _vm.downButtonListeners)) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cc2f615"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/inputnumber/InputNumber.vue
// module id = 2072
// module chunks = 0